// extracted by mini-css-extract-plugin
export var aboveInput = "_ne-0";
export var actionButton = "_ne-5";
export var actionButtonContainer = "_ne-1";
export var actionIcon = "_ne-6";
export var aiInfoContainer = "_ne-2";
export var attachmentWrapper = "_ne-7";
export var bold = "_ne-3";
export var checkIcon = "_ne-8";
export var clickingRecipientBar = "_ne-11";
export var commentThreadSwitch = "_ne-a";
export var draftImage = "_ne-b";
export var draftImageContainer = "_ne-c";
export var draftImages = "_ne-e";
export var editButton = "_ne-g";
export var editor = "_ne-f";
export var editorContainer = "_ne-y";
export var editorErrorTooltipWrapper = "_ne-9";
export var headerDivider = "_ne-h";
export var icon = "_ne-i";
export var info = "_ne-j";
export var internal = "_ne-n";
export var internalDivider = "_ne-k";
export var internalMessage = "_ne-l";
export var messageInputCard = "_ne-m";
export var messageInputForm = "_ne-o";
export var messageInputFormInternal = "_ne-p";
export var options = "_ne-q";
export var publicMessageCustomer = "_ne-s";
export var publicMessageMerchant = "_ne-r";
export var removeImageButton = "_ne-d";
export var replyButtons = "_ne-t";
export var showSignatureButton = "_ne-u";
export var spinner = "_ne-v";
export var verticalButtonDivider = "_ne-4";
export var visibilitySelector = "_ne-w";
export var warning = "_ne-x";
export var wrappingText = "_ne-z";
export var writingInternalNoteTopBorder = "_ne-10";